"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _variables = require("../../styles/variables");
var _animations = require("../../styles/animations");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBSplashScreen__Container",
  componentId: "sc-1iytfnj-0"
})(["position:fixed;top:0;left:0;height:100vh;width:100vw;display:flex;justify-content:center;align-items:center;z-index:", ";background-color:", ";"], _variables.Z_INDEX.SPLASH, _colors["default"].white);
var RootSpinner = _styledComponents["default"].div.withConfig({
  displayName: "HBSplashScreen__RootSpinner",
  componentId: "sc-1iytfnj-1"
})(["margin:0 auto;width:100px;text-align:center;div{width:16px;height:16px;background-color:", ";border-radius:100%;display:inline-block;margin-right:5px;animation:", " 1.7s infinite ease-in-out both;}"], _colors["default"].neutral600, _animations.skBounceDelay);
var Item1 = _styledComponents["default"].div.withConfig({
  displayName: "HBSplashScreen__Item1",
  componentId: "sc-1iytfnj-2"
})(["animation-delay:-0.6s !important;"]);
var Item2 = _styledComponents["default"].div.withConfig({
  displayName: "HBSplashScreen__Item2",
  componentId: "sc-1iytfnj-3"
})(["animation-delay:-0.4s !important;"]);
var Item3 = _styledComponents["default"].div.withConfig({
  displayName: "HBSplashScreen__Item3",
  componentId: "sc-1iytfnj-4"
})(["animation-delay:-0.2s !important;"]);
var HBSplashScreen = function HBSplashScreen(_ref) {
  var className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className,
    "data-testid": "hb-splashscreen"
  }, children, /*#__PURE__*/_react["default"].createElement(RootSpinner, null, /*#__PURE__*/_react["default"].createElement(Item1, null), /*#__PURE__*/_react["default"].createElement(Item2, null), /*#__PURE__*/_react["default"].createElement(Item3, null), /*#__PURE__*/_react["default"].createElement("div", null)));
};
var _default = exports["default"] = HBSplashScreen;
//# sourceMappingURL=HBSplashScreen.js.map